<template>
  <div>
    <DesktopView v-if="!isMobile && terminalMode === 'false'" />
    <TabletView v-if="terminalMode === 'true'" />

    <MobileView v-if="isMobile && terminalMode === 'false'" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MainMenu",
  route: "MainMenu",
  data() {
    return {
      isMobile: Helper.isMobile()
    };
  },
  computed: {
    ...mapGetters({
      terminalMode: "settings/terminalMode"
    })
  },
  components: {
    DesktopView: () => import("./DesktopView.vue"),
    MobileView: () => import("./MobileView.vue"),
    TabletView: () => import("./TabletView.vue")
  },
  created: async function () {
    await this.$store
      .dispatch("server/getSettings", this.$moment())
      .then(() => {})
      .catch((err) => {
        if (err.response.status != 200) {
          this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
        }
      });
    await this.$store
      .dispatch("user/getUserId")
      .then(async () => {
        if (this.$store.getters["user/user"].SAPEmpId == "0000") {
          this.$router.push("UserAdministration");
        }
      })
      .catch((err) => {
        if (err.response.status != 200) {
          //this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
        }
      });
  }
};
</script>
